<template>
  <path
    d="M16 10.0002H14V12.0002H16V10.0002ZM16 14.0002H14V16.0002H16V14.0002ZM8 10.0002H6V12.0002H8V10.0002ZM12 10.0002H10V12.0002H12V10.0002ZM20 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00018C22 4.90018 21.1 4.00018 20 4.00018ZM19 18.0002H5C4.45 18.0002 4 17.5502 4 17.0002V7.00018C4 6.45018 4.45 6.00018 5 6.00018H19C19.55 6.00018 20 6.45018 20 7.00018V17.0002C20 17.5502 19.55 18.0002 19 18.0002Z"
  />
</template>
